// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js!../../../../../node_modules/react-querybuilder/dist/query-builder.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.queryBuilder__operators {
    min-width: fit-content;
}

.queryBuilder__lookupVal {
    margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./../mirage/src/components/advancedQueryBuilder/advancedQueryBuilder.css"],"names":[],"mappings":"AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":["@import \"~react-querybuilder/dist/query-builder.css\";\n\n.queryBuilder__operators {\n    min-width: fit-content;\n}\n\n.queryBuilder__lookupVal {\n    margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
